<template>
  <div>
    
    <div class="row mt-4">
      <div class="col-md-8">
        <input class="input form-control"
               @keypress.enter="find()"
               v-model="query.generic"
               placeholder="Pesquisar por mesagem">
        <search-icon @click="find()" class="icon icon-within"/>
      </div>
  
      <div class="col-md-4">
        <span>
          Carregamento automático ({{ startTime >= 0 ? startTime : '...' }} s)
        </span>
      </div>
    </div>
    
    <hr>
    
    <div class="row">
      <div class="col-sm-12">
        
        <div class="row mt-4">
          <div class="col-md-12">
            <strong>
              {{infoTotalModels}}
            </strong>
          </div>
        </div>
  
        <div class="row mt-4">
          <div class="col-md-12">
            <QueueTable :queues="queues"/>
          </div>
        </div>
        
        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>
      
      </div>
    </div>
    
  </div>

</template>

<script>
  import Pagination from '@/components/shares/specialTag/Pagination'
  import QueueTable from '@/components/admin/sqs_messages/Table'
  import GlobalLoading from '@/mixins/GlobalLoading'
  import { SearchIcon } from 'vue-feather-icons'

  export default {
    beforeDestroy() {
      this.stopLoad()
    },
    components: { Pagination, QueueTable, SearchIcon },
    computed: {
      changeQuery() {
        return {}
      },
      infoTotalModels() {
        if (!this.meta.totalCount)
          return 'Nenhum registro'
  
        let page = this.meta.currentPage
        let perPage = this.meta.perPage
        let startPage = perPage * (page -1) + 1
        let lastPage = Math.min(perPage * page, this.meta.totalCount)
        return `Mostrando de ${startPage} até ${lastPage} de ${this.meta.totalCount} registro(s)`
      },
      numberOfBadges() {
        return 5
      },
      showFilter() {
        return true
      }
    },
    created() {
      this.find()
      this.startLoad()
    },
    data() {
      return {
        meta: {},
        query: {},
        queues: [],
        startTime: 20
      }
    },
    methods: {
      checkTime() {
        this.startTime--
        
        if (this.startTime === 0 && document.hidden)
          this.startTime = 20
        else if (this.startTime === 0)
          this.find()
      },
      find(page = null) {
        this.openGlobalLoad()
        const query = {...this.query}
        const params = page ? {page: page, q: query} : {q: query}
  
        this.axios.get('sqs_messages', {params: params})
          .then(response => {
            this.queues = this.$parse.toCamelcase(response.data)
            this.meta = this.$parse.toCamelcase(response.meta)
          })
          .catch(e => this.$notify.addError(e))
          .finally(() => {
            this.closeGlobalLoad()
            this.startTime = 20
          })
      },
      pagination(page) {
        this.find(page)
      },
      startLoad() {
        this.setInterval = setInterval(() => this.checkTime(), 1000)
      },
      stopLoad() {
        if (this.setInterval) clearInterval(this.setInterval)
      }
    },
    mixins: [GlobalLoading],
    name: 'SqsMessages'
  }
</script>

<style scoped>

</style>